<template>
  <div id="editUser" class="edit-user-container">
    <el-form
        :model="editUserData"
        :rules="rules"
        ref="editUserData"
        label-position="left"
        :disabled="isReadOnly"
        class="user-info-form"
    >
      <h1 class="section-title">基础个人信息</h1>

      <!-- 姓名 -->
      <el-form-item v-if="fieldShow('fullName')" :label="getLabelName('fullName')" prop="fullName">
        <el-input placeholder="请输入投稿人姓名" clearable v-model="editUserData.fullName"></el-input>
      </el-form-item>

      <!-- 医院 -->
      <el-form-item v-if="fieldShow('hospital')" :label="getLabelName('hospital')" prop="hospital">
        <el-select
            v-model="editUserData.hospital"
            filterable
            remote
            placeholder="请选择所属机构(可关键词搜索)"
            clearable
            :remote-method="getHospitalList"
            :loading="loading"
            @change="handleHospitalChange"
            allow-create
            default-first-option
            style="width: 100%"
        >
          <el-option v-for="(item,i) in options" :key="i" :label="item.hospitalName" :value="item.hospitalName"></el-option>
        </el-select>
      </el-form-item>

      <!-- 科室 -->
      <el-form-item v-if="fieldShow('department')" :label="getLabelName('department')" prop="department">
        <el-input placeholder="请输入所在科室" v-model="editUserData.department" clearable></el-input>
      </el-form-item>

<!--      &lt;!&ndash; 手机号 &ndash;&gt;-->
<!--      <el-form-item v-if="fieldShow('phoneNumber')" :label="getLabelName('phoneNumber')" prop="phoneNumber">-->
<!--        <el-input v-model="editUserData.phoneNumber" placeholder="请输入手机号" :max="11" clearable @blur="checkPhoneChange"></el-input>-->
<!--      </el-form-item>-->

<!--      &lt;!&ndash; 验证码 (仅当手机号修改时显示) &ndash;&gt;-->
<!--      <el-form-item label="验证码" prop="verifyCode" v-if="showVerifyCode && fieldShow('phoneNumber')">-->
<!--        <el-input v-model="editUserData.verifyCode" clearable placeholder="请输入验证码">-->
<!--          <el-button slot="append" @click="sendCodeFun(editUserData.phoneNumber)" :disabled="codeDisabled">-->
<!--            {{ codeText }}-->
<!--          </el-button>-->
<!--        </el-input>-->
<!--      </el-form-item>-->

      <!-- 地区 (级联选择器) -->
      <el-form-item v-if="fieldShow('area')" :label="getLabelName('area')" prop="regionCodes">
        <el-cascader
            :options="areas"
            v-model="editUserData.regionCodes"
            placeholder="请选择所属地区"
            style="width: 100%"
        ></el-cascader>
      </el-form-item>

      <!-- 职称 -->
      <el-form-item v-if="fieldShow('jobTitle')" :label="getLabelName('jobTitle')" prop="jobTitle">
        <el-select
            v-model="editUserData.jobTitle"
            filterable
            remote
            placeholder="请选择职称(可关键词搜索)"
            clearable
            :loading="loading"
            style="width: 100%"
        >
          <el-option v-for="(item,i) in jobTitleList" :key="i" :label="item.title" :value="item.title"></el-option>
        </el-select>
      </el-form-item>




      <!-- 提交按钮 -->
      <el-form-item class="options" v-if="!isReadOnly">
        <el-button
            class="submit-btn"
            @click="submitForm('editUserData')"
            :loading="submitLoading"
            :disabled="!editUserData.agreeChecked">
          {{ !editUserData.agreeChecked ? '请先勾选同意须知' : '提交保存' }}
        </el-button>
      </el-form-item>

      <!-- 只读状态提示 -->
      <el-alert v-else title="您的信息已备案成功，如需修改请联系管理员。" type="success" show-icon :closable="false"></el-alert>

    </el-form>

    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <!-- 用户须知弹窗 (简单模拟，实际可替换为具体内容) -->
    <el-dialog title="用户知情同意书" :visible.sync="dialogVisibleNotice" width="60%" append-to-body>
      <div style="height: 300px; overflow-y: auto; line-height: 1.6; color: #606266;">
        <p>尊敬的用户：</p>
        <p>欢迎您使用本案例投稿平台。在您使用本服务前，请务必仔细阅读以下条款...</p>
        <p>1. 您承诺提供的所有个人信息真实、准确、完整。</p>
        <p>2. 您授权平台在必要范围内收集、使用您的个人信息以进行身份核验。</p>
        <p>3. 您的优秀案例将在平台公开展示，请确保内容不侵犯第三方权益。</p>
        <p>...（此处省略详细条款）...</p>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="confirmNotice">我已阅读并同意</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import baseUrl from "@/request/config.js"
import {
  delCertificates,
  editUser,
  getUser,
  hospitalList,
  locationList,
  ProjectPage,
  sendCode,
  jobTitleList
} from '@/request/api.js';

import {
  provinceAndCityData
} from 'element-china-area-data'

export default {
  name: 'editUser',
  data() {
    // 自定义校验身份证号
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'));
      } else {
        const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的身份证号'));
        }
      }
    };
    // 自定义校验手机号
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!(/^1[3-9]\d{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    return {
      areas: provinceAndCityData,
      dialogVisibleNotice: false,
      baseUrl: '',
      submitLoading: false,
      file1: [], limit1: 3,
      file2: [], limit2: 1,
      file3: [], limit3: 1,
      file4: [], limit4: 3,
      otherList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      districtList: [],
      jobTitleList: [],
      editUserData: {
        fullName: "",
        cardId: '',
        bankNumber: '',
        bankName: '',
        branchName: '',
        hospital: '',
        department: '',
        phoneNumber: '',
        certificates: [],
        jobTitle: '',
        regionCodes: [], // 级联选择器用数组
        location: '',    // 兼容旧字段
        agreeChecked: false,
        certificatesStatus: ''
      },
      StatusConfig: [],
      userInfo: {},
      oldPhone: '',
      miaoCode: 60,
      codeText: '获取验证码',
      codeDisabled: false,
      showVerifyCode: false, // 控制验证码框显示
      rules: {
        fullName: [{ required: true, message: '请输入投稿人姓名', trigger: 'blur' }, { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }],
        cardId: [{ validator: validateIdCard, trigger: 'blur' }],
        hospital: [{ required: true, message: '请选择所属机构', trigger: 'change' }],
        department: [{ required: true, message: '请输入所在科室', trigger: 'blur' }],
        jobTitle: [{ required: true, message: '请选择职称', trigger: 'change' }],
        phoneNumber: [{ validator: validatePhone, trigger: 'blur' }],
        verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { pattern: /^[A-Za-z0-9]{4,6}$/, message: '验证码格式不正确', trigger: 'blur' }],
        regionCodes: [{ required: true, message: '请选择所属地区', trigger: 'change' }],
        bankNumber: [{ required: true, message: '请输入银行卡号', trigger: 'blur' }],
        branchName: [{ required: true, message: '请输入开户支行名称', trigger: 'blur' }]
      },
      options: [],
      loading: false,
      ProjectData: {}
    };
  },
  computed: {
    // 根据备案状态判断是否只读
    isReadOnly() {
      return this.editUserData.certificatesStatus === 'SUCCESS';
    }
  },
  created() {
    this.baseUrl = baseUrl;
    this.queryProject();
    this.getlocationList();
    this.getJobTitleList();
    this.getHospitalList();
    this.getUserFun();
  },
  methods: {
    // 获取请求头 (如果需要 token)
    getHeaders() {
      const token = localStorage.getItem('headToken') || localStorage.getItem('token');
      return token ? { 'Authorization': token } : {};
    },

    showNotice() {
      this.dialogVisibleNotice = true;
    },
    confirmNotice() {
      this.editUserData.agreeChecked = true;
      this.dialogVisibleNotice = false;
      this.$message.success('您已同意用户须知');
    },

    queryProject() {
      ProjectPage().then(res => {
        if (res.code == 200 && res.data.projectUserForm) {
          this.StatusConfig = JSON.parse(res.data.projectUserForm);
        }
      }).catch(err => console.log(err));
    },
    fieldShow(field) {
      // 默认显示，如果配置中明确为 false 则隐藏
      let status = true;
      const config = this.StatusConfig.find(item => item.key == field);
      if (config) status = config.value;
      return status;
    },
    getLabelName(field) {
      const config = this.StatusConfig.find(item => item.key == field);
      return config ? config.label : '';
    },
    openOther() {
      this.otherList.forEach(item => {
        if(item.fileName) window.open(item.fileName);
      });
    },
    getlocationList() {
      locationList().then(res => {
        if (res.code == 200) this.districtList = res.data;
      });
    },
    getJobTitleList() {
      jobTitleList().then(res => {
        if (res.code == 200) this.jobTitleList = res.data;
      });
    },
    handleHospitalChange(val) {
      // 可以在这里处理医院选择后的逻辑
    },
    checkPhoneChange() {
      // 检测手机号是否变化
      if (this.editUserData.phoneNumber && this.editUserData.phoneNumber !== this.oldPhone) {
        this.showVerifyCode = true;
        this.editUserData.verifyCode = ''; // 清空旧验证码
      } else {
        this.showVerifyCode = false;
      }
    },

    beforeRemove(file, fileList) {
      console.log('remove', file);
    },
    // 通用删除逻辑 (简化版，具体需根据后端 ID 逻辑调整)
    handleRemove1(file) {
      if (file.id) {
        delCertificates({ id: file.id }).then(res => {
          if (res.code == 200) this.$message.success('删除成功');
        });
      }
      // 移除本地列表
      this.file1 = this.file1.filter(f => f.uid !== file.uid);
      // 同步到 certificates 数组逻辑略 (参考原逻辑)
    },
    handleRemove2(file) {
      if (file.id) delCertificates({ id: file.id });
      this.file2 = this.file2.filter(f => f.uid !== file.uid);
    },
    handleRemove3(file) {
      if (file.id) delCertificates({ id: file.id });
      this.file3 = this.file3.filter(f => f.uid !== file.uid);
    },
    handleRemove4(file) {
      if (file.id) delCertificates({ id: file.id });
      this.file4 = this.file4.filter(f => f.uid !== file.uid);
    },

    handleExceed1(files, fileList) {
      this.$message.warning(`当前限制上传 ${this.limit1} 个文件`);
    },
    handleExceed2(files, fileList) {
      this.$message.warning(`当前限制上传 ${this.limit2} 个文件`);
    },
    handleExceed3(files, fileList) {
      this.$message.warning(`当前限制上传 ${this.limit3} 个文件`);
    },
    handleExceed4(files, fileList) {
      this.$message.warning(`当前限制上传 ${this.limit4} 个文件`);
    },
    beforeUploadCommon(file) {
      const isJPG = file.type.includes('image') || file.type.includes('pdf');
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) this.$message.error('只能上传图片或 PDF 文件!');
      if (!isLt5M) this.$message.error('上传文件大小不能超过 5MB!');
      return isJPG && isLt5M;
    },
    beforeUploadImg(file) {
      const isJPG = file.type.includes('image');
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) this.$message.error('只能上传图片文件!');
      if (!isLt5M) this.$message.error('上传文件大小不能超过 5MB!');
      return isJPG && isLt5M;
    },
    upSuccess1(res, file, fileList) {
      if (res.code == 200) {
        this.editUserData.certificates.push({ type: 'CONTRACT', fileName: res.data });
        this.file1 = fileList;
      }
    },
    upSuccess2(res, file, fileList) {
      if (res.code == 200) {
        if (res.data.cardId) {
          this.editUserData.cardId = res.data.cardId;
          this.$message.success('识别成功，信息已自动录入');
        } else {
          this.$message.warning('识别失败，请手动输入');
        }
        this.editUserData.certificates.push({ type: 'CARD', fileName: res.data.fileName });
        this.file2 = fileList;
      }
    },
    upSuccess3(res, file, fileList) {
      if (res.code == 200) {
        if (res.data.bankNumber) {
          this.editUserData.bankNumber = res.data.bankNumber;
          this.editUserData.bankName = res.data.bankName;
          this.$message.success('识别成功，信息已自动录入');
        }
        this.editUserData.certificates.push({ type: 'BANKCARD', fileName: res.data.fileName });
        this.file3 = fileList;
      }
    },
    upSuccess4(res, file, fileList) {
      if (res.code == 200) {
        this.editUserData.certificates.push({ type: 'CERTIFICATE', fileName: res.data });
        this.file4 = fileList;
      }
    },

    getUserFun() {
      getUser().then(res => {
        if (res.code == 200) {
          const data = res.data;
          this.userInfo = data;
          this.oldPhone = data.phoneNumber;

          // 填充表单
          this.editUserData.fullName = data.fullName;
          this.editUserData.cardId = data.cardId;
          this.editUserData.bankNumber = data.bankNumber;
          this.editUserData.bankName = data.bankName;
          this.editUserData.hospital = data.hospital;
          this.editUserData.department = data.department;
          this.editUserData.phoneNumber = data.phoneNumber;
          this.editUserData.jobTitle = data.jobTitle;
          this.editUserData.branchName = data.branchName;
          this.editUserData.certificatesStatus = data.certificatesStatus;
          this.editUserData.agreeChecked = true; // 默认勾选，或者根据需求设为 false

          // 处理地区 (兼容 code 数组或 id)
          if (data.regionCodes) {
            this.editUserData.regionCodes = data.regionCodes;
          }

          // 处理文件列表回显
          this.file1 = []; this.file2 = []; this.file3 = []; this.file4 = []; this.otherList = [];
          if (data.certificates) {
            data.certificates.forEach(item => {
              const fileObj = {
                name: item.fileName,
                url: item.fileName,
                id: item.id,
                status: 'success'
              };
              if (item.type == 'CONTRACT') this.file1.push(fileObj);
              else if (item.type == 'CARD') this.file2.push(fileObj);
              else if (item.type == 'BANKCARD') this.file3.push(fileObj);
              else if (item.type == 'CERTIFICATE') this.file4.push(fileObj);
              else this.otherList.push(item);
            });
          }
        }
      });
    },
    getHospitalList(query) {
      this.loading = true;
      hospitalList({ hospitalName: query || '' }).then(res => {
        this.loading = false;
        if (res.code == 200) this.options = res.data.records || [];
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url || file.response?.data;
      this.dialogVisible = true;
    },

    submitForm(formName) {
      if (!this.editUserData.agreeChecked) {
        this.$message.warning('请先勾选同意《用户知情同意书》');
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          // 构造提交数据
          let submitData = { ...this.editUserData };

          // 如果手机号没变，有些后端不需要传验证码，或者不需要传手机号
          if (this.oldPhone === submitData.phoneNumber) {
            // 可选：delete submitData.verifyCode;
            // 可选：delete submitData.phoneNumber;
          }

          editUser(submitData).then(res => {
            this.submitLoading = false;
            if (res.code == 200) {
              this.$notify({ title: '提交成功', message: res.msg || '信息更新成功', type: 'success' });
              // 关键：通知父组件
              this.$emit('editUserSuccess', { type: 'success', data: res.data });

              // 更新本地状态为 SUCCESS，防止重复提交
              if(res.data && res.data.certificatesStatus) {
                this.editUserData.certificatesStatus = res.data.certificatesStatus;
              }
            } else {
              this.$notify({ title: '提交失败', message: res.msg, type: 'error' });
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        } else {
          this.$message.error('请填写完整并修正错误信息');
          return false;
        }
      });
    },
    sendCodeFun(phone) {
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      this.codeDisabled = true;
      let count = 60;
      this.codeText = `${count}s`;
      const timer = setInterval(() => {
        count--;
        this.codeText = `${count}s`;
        if (count <= 0) {
          clearInterval(timer);
          this.codeDisabled = false;
          this.codeText = '获取验证码';
        }
      }, 1000);

      sendCode(phone).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.msg || '发送失败');
          clearInterval(timer);
          this.codeDisabled = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#editUser {
  padding: 10px;

  .section-title {
    font-size: 24px;
    font-weight: bold;
    color: #D43030;
    margin: 30px 0 20px;
    display: flex;
    align-items: center;

    .history-link {
      font-size: 14px;
      color: #909399;
      cursor: pointer;
      margin-left: 10px;
      text-decoration: underline;
      &:hover { color: #409EFF; }
    }
  }

  .upload-tip {
    font-size: 12px;
    color: #909399;
    margin: -10px 0 20px;
    line-height: 1.5;
  }

  ::v-deep .el-form-item {
    margin-bottom: 22px;

    .el-form-item__label {
      font-weight: bold;
      color: #333;
    }
  }

  ::v-deep .upload {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .el-upload-list__item {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }

    .el-upload {
      width: 100px;
      height: 100px;
    }
  }

  .agreement-item {
    ::v-deep .el-checkbox__label {
      color: #606266;
      font-size: 14px;

      .link-text {
        color: #409EFF;
        cursor: pointer;
        &:hover { text-decoration: underline; }
      }
    }
  }

  .options {
    margin-top: 30px;
    text-align: center;

    .submit-btn {
      width: 200px;
      height: 45px;
      font-size: 16px;
      background-color: #28B0A6;
      border-color: #28B0A6;
      color: #fff;

      &:hover {
        background-color: #239a91;
      }
    }
  }
}
</style>
